export enum Types {
  APPEND_MODAL_PRIORITY = 'APPEND_MODAL_PRIORITY',
  REMOVE_MODAL_PRIORITY = 'REMOVE_MODAL_PRIORITY'
}
